import { render, staticRenderFns } from "./TxrFilter.vue?vue&type=template&id=2a1196f4&"
import script from "./TxrFilter.vue?vue&type=script&lang=ts&"
export * from "./TxrFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mfe-shared/mfe-shared/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a1196f4')) {
      api.createRecord('2a1196f4', component.options)
    } else {
      api.reload('2a1196f4', component.options)
    }
    module.hot.accept("./TxrFilter.vue?vue&type=template&id=2a1196f4&", function () {
      api.rerender('2a1196f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TxrFilter.vue"
export default component.exports